// we-are-pixels-frontend/src/App.tsx (обновлённая версия)
import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation, useSearchParams } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { HomePage } from './pages/HomePage';
import { RegisterPage } from './pages/RegisterPage';
import { LoginPage } from './pages/LoginPage';
import { DashboardPage } from './pages/DashboardPage';
import { GamePage } from './pages/GamePage';
import { VerifyPage } from './pages/VerifyPage';
import { OAuthCallbackPage } from './pages/OAuthCallbackPage';
import { HistoryPage } from './pages/HistoryPage';
import { PrivateRoute } from './components/PrivateRoute';
import { AdminRoute } from './components/AdminRoute';
import { AdminPage } from './pages/AdminPage';
import { AboutPage } from './pages/AboutPage';
import { CookieBanner } from './components/CookieBanner';
import { PageViewTracker } from './hooks/useAnalytics';
import './styles/global.scss';

/** Redirect to /dashboard while forwarding any existing query params (e.g. ?payment=success) */
const DashboardRedirect: React.FC = () => {
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const next = new URLSearchParams(searchParams);
  if (!next.get('tab')) {
    if (location.pathname === '/profile') next.set('tab', 'profile');
    if (location.pathname === '/zones') next.set('tab', 'zones');
  }
  const qs = next.toString();
  return <Navigate to={qs ? `/dashboard?${qs}` : '/dashboard'} replace />;
};

function App() {
  return (
    <BrowserRouter>
      <PageViewTracker />
      <ToastContainer theme="dark" />
      <CookieBanner />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/verify/:token" element={<VerifyPage />} />
        <Route path="/auth/callback" element={<OAuthCallbackPage />} />
        <Route path="/dashboard" element={<PrivateRoute><DashboardPage /></PrivateRoute>} />
        <Route path="/profile" element={<PrivateRoute><DashboardRedirect /></PrivateRoute>} />
        <Route path="/shop" element={<PrivateRoute><DashboardRedirect /></PrivateRoute>} />
        <Route path="/zones" element={<PrivateRoute><DashboardRedirect /></PrivateRoute>} />
        <Route path="/game/:pointId" element={<PrivateRoute><GamePage /></PrivateRoute>} />
        <Route path="/history" element={<HistoryPage />} />
        <Route path="/admin" element={<AdminRoute><AdminPage /></AdminRoute>} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
